"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon/icon"));

var _footerLinks = _interopRequireDefault(require("../footerLinks/footerLinks"));

var _floater = _interopRequireDefault(require("../floater/floater"));

var _utils = require("./utils");

/* eslint-disable class-methods-use-this */

/* eslint-disable react/jsx-fragments */
var SIDEBAR_TOGGLE_ICON = /*#__PURE__*/_react["default"].createElement("svg", {
  version: "1.1",
  className: "oui-expanded oui-toggle-icon",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  width: "12px",
  height: "12px",
  viewBox: "0 0 451.846 451.847"
}, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744 L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284 c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
})));

var SIDEBAR_PIN_ICON = /*#__PURE__*/_react["default"].createElement("svg", {
  id: "Layer_2",
  className: "oui-pin",
  "data-name": "Layer 2",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  width: "12px",
  height: "12px",
  viewBox: "0 0 34.12 34.12"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M583.08,882.79l-9.9-9.9a1,1,0,0,0-1.41,0l-1.41,1.41a1,1,0,0,0,0,1.41l0.71,0.71-11.31,11.31-2.12-2.12a1,1,0,0,0-1.41,0L554.8,887a1,1,0,0,0,0,1.41l12.73,12.73a1,1,0,0,0,1.41,0l1.41-1.41a1,1,0,0,0,0-1.41l-2.12-2.12,11.31-11.31,0.71,0.71a1,1,0,0,0,1.41,0l1.41-1.41A1,1,0,0,0,583.08,882.79Z",
  transform: "translate(-549.25 -872.6)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M549.84,903.31a2,2,0,0,0,2.83,2.83l10.62-9.2L559,892.7Z",
  transform: "translate(-549.25 -872.6)"
}));

var SidebarUtils = /*#__PURE__*/function () {
  function SidebarUtils(context) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, SidebarUtils);
    (0, _defineProperty2["default"])(this, "renderFloatingSidebar", function (props) {
      var _ref = _this.context || {},
          dellDoubleHeader = _ref.dellDoubleHeader;

      return /*#__PURE__*/_react["default"].createElement(_floater["default"], {
        position: props["float"].direction,
        show: props["float"].visible,
        overlay: true,
        onOverlayClick: props["float"].toggle,
        onShow: props.onExpand,
        onHide: props.onCollapse
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": props.dataTestId,
        className: (0, _utils.gatherClasses)(props, "oui-sidebar-container", dellDoubleHeader && "oui-double-header-support", "oui-sidebar-floating")
      }, props["float"].direction === "left" && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-position-relative"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-separator-line"
      })), _this.renderSections(props.sections, true), _this.renderSidebarFooter(props.footerLinks)));
    });
    (0, _defineProperty2["default"])(this, "renderStaticSidebar", function (props) {
      var isCollapsed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isHoverable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var toggle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
      var isTabletView = arguments.length > 4 ? arguments[4] : undefined;
      var innerRef = arguments.length > 5 ? arguments[5] : undefined;

      var _ref2 = _this.context || {},
          dellDoubleHeader = _ref2.dellDoubleHeader;

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        ref: innerRef,
        "data-testid": props.dataTestId,
        className: (0, _utils.gatherClasses)(props, "oui-sidebar-container", dellDoubleHeader && "oui-double-header-support", "oui-sidebar-static", props.collapsible && isCollapsed ? "oui-sidebar-collapsed" : null, props.collapsible && isHoverable ? "oui-sidebar-hoverable" : null, props.honourGlobalFooter ? "oui-sidebar-honour-global-footer" : null, props.honourPageAlert ? "oui-sidebar-honour-page-alert" : null)
      }, !isTabletView && props.collapsible && isCollapsed && isHoverable && _this.renderCollapseToggler(toggle, isCollapsed, true), _this.renderSidebarHeading(props), props.site && _this.renderSite(props.site, isCollapsed), _this.renderSections(props.sections, false)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-sidebar-placeholder"
      }), !isTabletView && props.collapsible && !isCollapsed && !isHoverable && _this.renderCollapseToggler(toggle, isCollapsed, false));
    });
    (0, _defineProperty2["default"])(this, "renderCollapseToggler", function (toggle, isCollapsed, isPositionedFixed) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _utils.gatherClasses)(null, isPositionedFixed ? "oui-collapse-toggler-static" : "oui-collapse-toggler-fixed", "oui-collapse-toggler"),
        onClick: toggle,
        "aria-hidden": "true"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        svg: isCollapsed ? SIDEBAR_PIN_ICON : SIDEBAR_TOGGLE_ICON
      }));
    });
    (0, _defineProperty2["default"])(this, "renderSidebarHeading", function (props) {
      var sidebarName = props.sidebarName;

      if (_this.context && _this.context.isDellApplication() && sidebarName) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-sidebar-heading"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-sidebar-heading-text"
        }, /*#__PURE__*/_react["default"].createElement("hr", {
          className: "oui-sidebar-heading-separator-line",
          "data-content": sidebarName
        })));
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "renderSidebarFooter", function (links) {
      if (_this.context && _this.context.isDellApplication()) {
        return links && links.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-floating-sidebar-footer-container"
        }, /*#__PURE__*/_react["default"].createElement(_footerLinks["default"], {
          inSidebar: true,
          links: links
        }));
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "renderSite", function (site, isCollapsed) {
      var _site$circledIcon = site.circledIcon,
          circledIcon = _site$circledIcon === void 0 ? true : _site$circledIcon;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("oui-site-container")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          "oui-site-circled-icon-container": circledIcon
        })
      }, site.icon ? /*#__PURE__*/_react["default"].isValidElement(site.icon) ? /*#__PURE__*/_react["default"].cloneElement(site.icon, {
        className: (0, _utils.gatherClasses)(null, "oui-site-icon", site.icon.props.className),
        size: "md",
        width: circledIcon ? 16 : isCollapsed ? 36 : 48,
        height: circledIcon ? 16 : isCollapsed ? 36 : 48,
        muted: false
      }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({}, site.icon, {
        width: "".concat(circledIcon ? 16 : isCollapsed ? 36 : 48, "px"),
        height: "".concat(circledIcon ? 16 : isCollapsed ? 36 : 48, "px"),
        muted: false,
        className: (0, _utils.gatherClasses)(site.icon, "oui-site-icon")
      })) : null), site.name ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-site-name"
      }, /*#__PURE__*/_react["default"].createElement("div", null, site.name), site.subtitle && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-site-subtitle"
      }, site.subtitle)) : null);
    });
    (0, _defineProperty2["default"])(this, "renderSections", function (sections) {
      var isFloating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _utils.gatherClasses)(null, "oui-sidebar-sections", isFloating ? "oui-invert-scroll" : null)
      }, (0, _map["default"])(sections).call(sections, function (section, index) {
        var isDivider = _this.isSectionDivider(section);

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _utils.gatherClasses)(null, "oui-sidebar-section"),
          key: "sidebar-section-".concat(index)
        }, !isDivider ? _this.renderSingleSection(section) : _this.renderSectionDivider());
      }));
    });
    this.context = context;
  }

  (0, _createClass2["default"])(SidebarUtils, [{
    key: "isSectionDivider",
    value: function isSectionDivider(section) {
      var divider = section.divider,
          component = section.component;

      if (!!divider && !!component) {
        throw new Error("<Sidebar />: Both divider and component cannot be passed together in a sidebar section");
      }

      return divider === true;
    }
  }, {
    key: "renderSingleSection",
    value: function renderSingleSection(section) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, section.heading && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-section-heading oui-h6 oui-text-truncate"
      }, section.heading), (0, _utils.isFunction)(section.component) && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _utils.gatherClasses)(section, "oui-sidebar-section-component")
      }, section.component()));
    }
  }, {
    key: "renderSectionDivider",
    value: function renderSectionDivider() {
      return /*#__PURE__*/_react["default"].createElement("hr", {
        className: "oui-sidebar-section-divider"
      });
    }
  }]);
  return SidebarUtils;
}();

exports["default"] = SidebarUtils;